export function saveCountrySettings(country) {
    localStorage.setItem('customCountry', country);
}

export function isCountrySk() {
    //try to get the language from previously saved settin in local storage
    let countryPreferences = localStorage.getItem('customCountry');

    //if there is no previously saved settings, get the language from browser
    if ( countryPreferences) {
        return countryPreferences === 'SK';
    }
    const browserLang = navigator.language || navigator.userLanguage;
    return browserLang.indexOf('sk') !== -1;
}
